// Contexto de usuario registrado
import React from "react";

const UseContext = React.createContext({
  name: "Guest"
});

export default UseContext;
